import React from 'react'
import { Box, Typography, Button, IconButton } from "@mui/material";
import { AccessTime } from '@mui/icons-material';
import { Navigate, useNavigate } from 'react-router-dom';
export const VerificationPending = () => {
    const navigate = useNavigate();
    return (
        <div
            style={{
                // width: '400px',
                height: '300px',
                background: 'linear-gradient(180deg, #FFE5D8 0%, #FFF7F3 100%)',
                borderRadius: '16px',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
                position: 'relative',
            }}
        >
            {/* Icon */}
            <Box
                sx={{
                    width: 72,
                    height: 72,
                    background: 'linear-gradient(180deg, #FFD9B3 0%, #FFA25C 100%)',
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <AccessTime
                    sx={{ fontSize: 40, color: '#FFF' }}
                />
            </Box>

            {/* Title */}
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 600,
                    color: '#4F4F4F',
                    marginTop: 2,
                }}
            >
                Verification Pending
            </Typography>

            {/* Description */}
            <Typography
                variant="body2"
                sx={{
                    color: '#828282',
                    textAlign: 'center',
                    marginTop: 1,
                }}
            >
                Your details are being reviewed. We’ll notify you once the verification
                is complete.
            </Typography>

            {/* Button */}
            <Button
                variant="contained"
                sx={{
                    marginTop: 2,
                    background: 'linear-gradient(90deg, #FF512F 0%, #FF9049 100%)',
                    color: '#FFF',
                    fontWeight: 600,
                    borderRadius: '24px',
                    textTransform: 'none',
                    paddingX: 4,
                    paddingY: 1.5,
                    '&:hover': {
                        background: 'linear-gradient(90deg, #FF512F 0%, #FF9049 100%)',
                    },
                }}
                onClick={() => navigate('/')}
            >
                Done
            </Button>
        </div>
    )
}
